import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function Items() {
  const [searchTerm, setSearchTerm] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api(`/items`)
      .then(res => res.json())
      .then(data => {
        setItems(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const filteredItems = items.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.sku || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.barcode || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.description || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout>
          <div className="bg-white rounded-lg shadow">
            <div className="p-6 border-b">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold text-gray-900">Items</h1>
                <Link to="/inventory/items/new" className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
                  Add Item
                </Link>
              </div>
              <input
                type="text"
                placeholder="Search items by name, SKU, barcode, or description..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
              />
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">SKU</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Barcode</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Description</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Created</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredItems.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                        <Link to={`/inventory/items/${item.id}`} className="text-red-600 hover:text-red-800">{item.name}</Link>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-600">{item.sku || '—'}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-600">{item.barcode || '—'}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">{item.description || '—'}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">
                        {new Date(item.createdAt).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {loading && (
                <div className="text-center py-12 text-gray-500">Loading...</div>
              )}
              {!loading && filteredItems.length === 0 && (
                <div className="text-center py-12 text-gray-500">
                  No items found.
                </div>
              )}
            </div>
          </div>
    </Layout>
  );
}
